






import { computed, defineComponent } from '@vue/composition-api';
// import {  } from '@ideavivat/vivat-2';

import Loading from '@/components/Loading.vue';

const App = defineComponent({
  components: {
    Loading,
  },
  setup(props: any, { root }: any) {
    const computedLoading = computed(() => root.$store.state.loading);

    return {
      computedLoading,
    };
  },
});

export default App;
